import { Mail, ArrowRight } from "lucide-react";
import { Container, Reveal } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import { COMPANY } from "@/data/content";

const steps = [
  "We review your facilities, usage, and current contracts.",
  "We model options and recommend a procurement strategy.",
  "We manage the process and monitor markets on your behalf.",
];

export default function HomeContact() {
  return (
    <section id="contact" className="bg-ice py-24 md:py-32">
      <Container>
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <p className="overline text-electric">Contact</p>
            <h2 className="mt-4 font-heading text-3xl font-semibold leading-[1.1] tracking-tight text-navy sm:text-4xl lg:text-5xl">
              Let's talk about your energy strategy.
            </h2>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-slatey">
              Whether you're renewing a contract, entering a new market, or hosting
              battery storage in our Virtual Power Plant Network, our advisors are ready to help.
            </p>

            <div className="mt-10 space-y-4">
              {steps.map((s, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <div className="flex items-start gap-4">
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-electric font-mono text-xs text-electric">
                      {i + 1}
                    </span>
                    <p className="text-navy/80">{s}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <a
              href={`mailto:${COMPANY.email}`}
              className="mt-10 inline-flex items-center gap-3 border-t border-line pt-8 text-navy"
            >
              <Mail className="h-5 w-5 text-electric" />
              <span className="font-medium">{COMPANY.email}</span>
              <ArrowRight className="h-4 w-4 text-slatey" />
            </a>
          </div>

          <Reveal delay={0.1}>
            <div className="border border-line bg-white p-8 md:p-10">
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
